<div class="dashboard-container">
  <div class="dashboard-card">
    <div class="header">
      <h1>You are already logged in with user : {{ username }}</h1>
    </div>

    <div class="tools-grid">
      <button class="tool-card" (click)="navigateToSwagger()" type="button">
        <h2>Swagger UI</h2>
      </button>

      <button class="tool-card disabled" type="button" disabled>
        <h2>Hangfire</h2>
      </button>
    </div>

    <div class="logout-section">
      <a href="javascript:void(0)" (click)="logout()" class="logout-link">Logout</a>
    </div>
  </div>
</div>
